import store from '@/store'
import router from '@/router'
import { RouteConfig } from '@/config'
import { BookingSummary } from '@/services/BookingService.interface'

/**
 * After username/password login (or register/refresh), choose the destination section:
 * - Restore booking/quote connect deep-link if auth interrupted it
 * - Booking section if there is a current booking
 * - Quote section if there is no booking but a quote exists
 * - Booking section (empty state) otherwise
 *
 * Does not auto-open the booking/quote panel — that is only for connect deep-links.
 */
const navigateAfterAuth = async (userEmail?: string): Promise<void> => {
  const pendingRedirect = sessionStorage.getItem('pendingAuthRedirect')
  if (pendingRedirect) {
    sessionStorage.removeItem('pendingAuthRedirect')
    await router.push(pendingRedirect)
    return
  }

  const email = userEmail || store.state.auth?.user?.email

  if (!email) {
    await router.push(`/account/${RouteConfig.CONFIRMED}`)
    return
  }

  try {
    await store.dispatch('booking/fetchBookings', { userEmail: email })

    const currentBookings: BookingSummary[] =
      store.getters['booking/currentBookings'] || []
    const quotes: BookingSummary[] =
      store.getters['booking/quotesAndCartInProgress'] || []

    if (currentBookings.length) {
      await router.push(`/account/${RouteConfig.CONFIRMED}`)
      return
    }

    if (quotes.length) {
      await router.push(`/account/${RouteConfig.QUOTE}`)
      return
    }
  } catch (error) {
    console.error('Error determining post-auth destination:', error)
  }

  await router.push(`/account/${RouteConfig.CONFIRMED}`)
}

export default navigateAfterAuth
